export enum Country {
	EU = "EU",
	NON_EU = "Non EU",
}



// WEBPACK FOOTER //
// ./Frontend/src/entity/Country.ts